import React, { useEffect, useMemo, useState } from 'react';
import { TZ_ULKELER, tzSecenekleri } from '../data/tzCatalog';
import { locationEtiketi, kuralEksigi } from './DutyLocationRules';

import HarfliGiris from './HarfliGiris';
import MeydanGirisi, { meydanBilgisi } from './MeydanGirisi';
import { dugmeStili, zorunluAlan } from './tasarim';
// LOCATION SECICI — yer gorevi ve egitim kayitlari icin.
//
// Serkan (1 Eyl 2026): *"Her kutuda OTHER secenegi olsun, en tepede. Ona
//  tiklayinca yazsin, ADD diye sorsun."* ve *"ekler oracikta"* — sehir listesi
//  ayri bir admin ekranindan degil, formun ICINDEN buyur. Girdigin an duruyorsun,
//  sehir yoksa oradan eklersin.
//
// ┌ IKI KADEME ────────────────────────────────────────────────────────────┐
// │ ULKE  -> SEHIR   ("once ulkeyi secelim, ulkeyi secince sehirler ciksin")│
// │ Ikisinde de OTHER EN TEPEDE.                                            │
// └────────────────────────────────────────────────────────────────────────┘
//
// 🔑 DILIM SORUSU 216 ULKEDE HIC CIKMAZ. Olculdu (1 Eyl): 247 ulkenin 216'si
// TEK dilimli — orada dilim otomatik gelir, kullaniciya sorulmaz. Yalniz 31
// ulkede (US 29 · RU 26 · CA 23 · BR 16 · AU 12 …) bolge secimi cikar; bu tam
// olarak Serkan'in *"tek istisna Amerika olabilir, orada eyaletler cikar"*
// dedigi durumdur.
//
// 🔑 Sehir listesi BIZIM (`duty_locations`), IANA katalogu yalnizca DILIM
// KAYNAGI. Sebep: zone.tab dilim basina tek temsilci sehir tasir (UK icin
// yalnizca LONDON) — onu sehir listesi yapsaydik Farnborough'daki egitim
// kayda "LONDON/UK" diye gecerdi: saat dogru, KAYIT SADIK DEGIL.

export const OTHER = '__OTHER__';

const C = { t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)', border:'var(--border)',
            accent:'var(--accent)', red:'var(--red)' };
const S = {
  label:{ fontSize:10, color:C.t2, fontWeight:700, letterSpacing:1.5, textTransform:'uppercase',
          fontFamily:'var(--mono)', display:'block', marginBottom:6 },
  input:{ background:'var(--input-bg)', border:`1px solid ${C.border}`, borderRadius:6,
          color:'var(--t1)', padding:'9px 11px', fontSize:13, fontFamily:'var(--mono)',
          width:'100%', boxSizing:'border-box', outline:'none' },
  btn:{ background:C.accent, color:'#fff', border:'none', borderRadius:6, padding:'9px 16px',
        fontSize:11, fontFamily:'var(--mono)', fontWeight:700, letterSpacing:1.5,
        cursor:'pointer', textTransform:'uppercase' },
  // 1 Eki 2026 — düğmeler ORTAK tasarımdan (tasarim.js, Serkan: "her modülün içinde butonlarda border, aynı tasarım"); eskiden bu dosyada ayrı tanımlıydı.
  btnS:dugmeStili('notr', { kucuk: true }),
  not:{ fontSize:10, color:C.t3, fontFamily:'var(--mono)', marginTop:6, lineHeight:1.6 },
};

// ── SAF YARDIMCILAR (test edilebilir, React'siz) ───────────────────────────

/** ULKE secenekleri — IKI GRUP: once KULLANDIKLARIMIZ, sonra TAMAMI.
 *
 * 🔴 1 Eyl 2026, iki kez yanlis kuruldu, ikisini de Serkan duzeltti:
 *   ① Once liste yalniz "elimizdekiler + OTHER" idi. Ilk gun bos oldugu icin
 *      ekranda tek secenek `OTHER…` kaldi.
 *   ② Sonra Claude bunu tam kataloga cevirdi; Serkan: *"yanlis tasarim —
 *      elimizdekiler cikacak, bulamazsak OTHER'i secicez."* Geri alindi.
 *   ③ Geri alinan hal de kusurluydu: OTHER'a tiklayinca IKINCI bir bos kutu
 *      aciliyor, listeyi TEKRAR acmak gerekiyordu. Serkan: *"other tiklayinca
 *      select country cikiyor, mantik yanlis — ilk sectigimizde direk ulkeler
 *      cikmali."*
 *
 * 🔑 DOGRUSU: ULKE icin OTHER'a GEREK YOK — aranan ulke listede ZATEN var
 * (247 tanesi de). Kullandiklarimiz yalnizca EN USTE alinir (Serkan'in
 * "elimizdekiler cikacak" kurali), gerisi altta durur. `OTHER…` sadece SEHIR
 * kutusunda kalir, cunku orada eklenecek bir sey vardir.
 *
 * @returns {{kullanilan: Array, tumu: Array}} */
export function ulkeSecenekleri(kayitli = []) {
  const kodlar = new Set();
  for (const r of kayitli) {
    if (r?.active === false) continue;
    const cc = String(r?.country_code || '').toUpperCase();
    if (cc) kodlar.add(cc);
  }
  const ad = (cc) => TZ_ULKELER.find(u => u.cc === cc)?.ulke || cc;
  // ALL grubu KULLANILANLARI ICERMEZ: ayni ulke iki kez gorunurse liste
  // gurultulu olur ve "hangisini secsem" sorusu dogar. Her ulke TAM BIR KEZ.
  return {
    kullanilan: [...kodlar].sort().map(cc => ({ cc, ulke: ad(cc) })),
    tumu: TZ_ULKELER.filter(u => !kodlar.has(u.cc)).map(u => ({ cc: u.cc, ulke: u.ulke })),
  };
}

/** Secili ulkenin SEHIR secenekleri. OTHER her zaman EN TEPEDE. */
export function sehirSecenekleri(kayitli = [], cc) {
  const k = String(cc || '').toUpperCase();
  const bizim = kayitli
    .filter(r => r?.active !== false && String(r?.country_code || '').toUpperCase() === k)
    .map(r => ({ city: String(r.city || '').toUpperCase(), tz: r.iana_tz, id: r.id }))
    .sort((a, b) => a.city.localeCompare(b.city));
  return [{ city: OTHER, tz: null, id: OTHER }, ...bizim];
}

/** Bu ulkede dilim SORULMALI mi? Tek dilimliyse sorulmaz (216 ulke boyle). */
export function dilimSorulmali(cc) {
  return tzSecenekleri(String(cc || '').toUpperCase()).length > 1;
}

/** Tek dilimli ulkenin dilimi — sorulmadan kullanilir. Cok dilimliyse null. */
export function tekDilim(cc) {
  const s = tzSecenekleri(String(cc || '').toUpperCase());
  return s.length === 1 ? s[0].tz : null;
}

// ── BILESEN ────────────────────────────────────────────────────────────────

/**
 * @param kural      'city' | 'icao' | 'none'  (DutyLocationRules.locationKurali)
 * @param value      { location, location_tz }
 * @param locations  duty_locations satirlari (musterinin sehirleri)
 * @param onChange   ({location, location_tz}) => void
 * @param onAdd      async ({city, country_code, iso_code, iana_tz}) => eklenen satir
 */
export default function LocationPicker({ kural, value, locations = [], onChange, onAdd, disabled,
                                        icaoEtiketi = 'Airport (ICAO)',
                                        icaoNotu = 'Standby at an aerodrome — the timezone comes from the airport.',
                                        icaoPlaceholder = 'LTFE', testId = 'location-icao', zorunlu = false }) {
  // ZORUNLU ALAN RENGİ (5 Eki 2026, iPad'in aynısı): `zorunlu` verilirse (ASSIGN yer görevi) renk kapının KENDİ kuralından —
  // `kuralEksigi`, `locationEksigi`nin içi. OFF'un yeri zorunlu değildir, orada verilmez.
  const yerEksik = zorunlu ? kuralEksigi(kural, { location: value?.location, locationTz: value?.location_tz, icao: value?.location }) : null;
  const zr = (dolu) => zorunluAlan(zorunlu, dolu);
  const [cc, setCc]           = useState(() => (value?.location || '').split('/')[1] || '');
  // 🔴 1 Eyl, Serkan: *"ayni sey sehir listesinde de oluyor."* Sebep: kutunun
  // degeri SECILI SEHRE bagliydi ve OTHER bir sehir olmadigi icin secim
  // aninda kutu `—`'ye GERI DONUYORDU — tiklıyorsun, hicbir sey olmamis gibi
  // gorunuyor. Artik OTHER acik bir MODDUR: kutu OTHER'da kalir, ekleme alani
  // ancak o zaman acilir.
  const [ekleMod, setEkleMod] = useState(false);
  const [yeniSehir, setYeniSehir] = useState('');
  const [yeniTz, setYeniTz]   = useState('');
  const [ekleniyor, setEkleniyor] = useState(false);
  const [hata, setHata]       = useState(null);

  const ulkeler  = useMemo(() => ulkeSecenekleri(locations), [locations]);
  const sehirler = useMemo(() => sehirSecenekleri(locations, cc), [locations, cc]);
  const secilenSehir = (value?.location || '').split('/')[0] || '';

  // 🔑 1 Eki 2026 — ICAO TEK TİP (OFF'un yeri + meydan nöbeti; Serkan: "ICAO kod girelim, hızlı"): kod ortak
  //    meydan listesinde aranır (`meydanBilgisi`, MeydanGirisi'nin sorgusu) ve DİLİM KAYDA yazılır. Listede yoksa
  //    dilim boş kalır → `locationEksigi`/`offYeriEksigi` eksik sayar, kaydettirmez.
  // 🔴 ÖNCESİ: dilim null yazılıyor ("acclTz'den çözülür") ama çözen yer yoktu; kod listede aranmıyordu.
  const icaoKod = kural === 'icao' ? String(value?.location || '').toUpperCase() : '';
  const kayitliTz = value?.location_tz || null;
  useEffect(() => {
    if (kural !== 'icao' || !/^[A-Z]{4}$/.test(icaoKod)) return undefined;
    let dead = false;
    meydanBilgisi(icaoKod).then(b => {
      if (dead || !b) return;                              // bilinmiyor (ağ) — dokunma
      const tz = b.var ? b.tz : null;
      if (tz !== kayitliTz) onChange({ location: icaoKod, location_tz: tz });
    });
    return () => { dead = true; };
  }, [kural, icaoKod]);   // eslint-disable-line react-hooks/exhaustive-deps

  if (kural === 'none') return null;

  // MEYDAN NOBETI — ICAO (Serkan: "airport stby icao"). Meydan nobeti tanimi
  // geregi bir meydandadir; ICAO hem daha kesin hem `acclTz[ICAO]` zaten var.
  if (kural === 'icao') {
    return (
      <div>
        <label style={S.label}>{icaoEtiketi}</label>
        <MeydanGirisi style={{ ...S.input, ...zr(!yerEksik).style }} data-zorunlu={zr(!yerEksik)['data-zorunlu']}
               disabled={disabled} data-testid={testId}
               value={icaoKod}
               placeholder={icaoPlaceholder}
               onChange={v => onChange({
                 // Rakam/noktalama SÜZÜLMEYE devam eder — ICAO dört HARFTİR.
                 // A–Z dışı harf ise artık buraya HİÇ gelmez: `HarfliGiris`
                 // reddeder ve alanın altında söyler (20 Eyl 2026).
                 location: String(v || '').toUpperCase().replace(/[^A-Z]/g, ''),
                 location_tz: null,   // dilim yukarıdaki etkiyle meydan listesinden okunur
               })} />
        {kayitliTz && icaoKod.length === 4 && (
          <div style={S.not} data-testid={`${testId}-dilim`}>{icaoKod} · {kayitliTz}</div>)}
        <div style={S.not}>{icaoNotu}</div>
      </div>
    );
  }

  const ulkeSec = (v) => {
    setHata(null);
    setCc(v); setEkleMod(false); setYeniSehir(''); onChange({ location:'', location_tz:null });
  };

  const sehirSec = (v) => {
    setHata(null);
    if (v === OTHER) {
      setEkleMod(true);
      setYeniSehir('');
      setYeniTz(tekDilim(cc) || '');
      onChange({ location: '', location_tz: null });
      return;
    }
    setEkleMod(false);
    const r = sehirler.find(s => s.city === v);
    onChange({ location: locationEtiketi(v, cc), location_tz: r?.tz || null });
  };

  const ekle = async () => {
    const sehir = yeniSehir.trim().toUpperCase();
    const tz = yeniTz || tekDilim(cc);
    // Dilimi bilinmeyen sehir EKLENEMEZ: etiketi olan ama hesabi olmayan
    // kayit dogardi (Ilke 1). Semada da `iana_tz NOT NULL`.
    if (!sehir) { setHata('Enter the city name.'); return; }
    if (!tz)    { setHata('Choose the region — this country has more than one timezone.'); return; }
    setEkleniyor(true); setHata(null);
    try {
      const iso = (TZ_ULKELER.find(u => u.cc === cc)?.iso) || cc;
      await onAdd({ city: sehir, country_code: cc, iso_code: iso, iana_tz: tz });
      onChange({ location: locationEtiketi(sehir, cc), location_tz: tz });
      setYeniSehir(''); setEkleMod(false);
    } catch (e) {
      setHata('The city could not be saved. Check the connection and try again.');
    } finally { setEkleniyor(false); }
  };

  return (
    <div style={{ display:'grid', gap:10 }}>
      <div>
        <label style={S.label}>Country</label>
        <select style={{ ...S.input, ...zr(!!cc).style }} data-zorunlu={zr(!!cc)['data-zorunlu']} disabled={disabled} value={cc}
                onChange={e => ulkeSec(e.target.value)}>
          <option value="">—</option>
          {ulkeler.kullanilan.length > 0 && (
            <optgroup label="USED">
              {ulkeler.kullanilan.map(u => (
                <option key={`k-${u.cc}`} value={u.cc}>{u.cc} — {u.ulke.toUpperCase()}</option>
              ))}
            </optgroup>
          )}
          <optgroup label="ALL COUNTRIES">
            {ulkeler.tumu.map(u => (
              <option key={u.cc} value={u.cc}>{u.cc} — {u.ulke.toUpperCase()}</option>
            ))}
          </optgroup>
        </select>
      </div>

      {!!cc && (
        <div>
          <label style={S.label}>City</label>
          <select style={{ ...S.input, ...zr(!yerEksik).style }} data-zorunlu={zr(!yerEksik)['data-zorunlu']} disabled={disabled}
                  value={ekleMod ? OTHER : secilenSehir}
                  onChange={e => sehirSec(e.target.value)}>
            <option value="">—</option>
            {sehirler.map(s => (
              <option key={s.id} value={s.city}>{s.city === OTHER ? 'OTHER…' : s.city}</option>
            ))}
          </select>
        </div>
      )}

      {!!cc && ekleMod && (
        <div style={{ display:'grid', gap:8, padding:'10px 12px',
                      border:`1px dashed ${C.border}`, borderRadius:8 }}>
          <label style={S.label}>Add city</label>
          <HarfliGiris style={S.input} value={yeniSehir} disabled={disabled || ekleniyor}
                 placeholder="E.G. FARNBOROUGH"
                 onChange={setYeniSehir} />
          {dilimSorulmali(cc) && (
            <>
              <label style={S.label}>Region / timezone</label>
              <select style={S.input} value={yeniTz} disabled={disabled || ekleniyor}
                      onChange={e => setYeniTz(e.target.value)}>
                <option value="">— SELECT REGION —</option>
                {tzSecenekleri(cc).map(r => (
                  <option key={r.tz} value={r.tz}>
                    {r.sehir}{r.not ? ` — ${r.not}` : ''}
                  </option>
                ))}
              </select>
            </>
          )}
          <div>
            <button type="button" style={S.btn} disabled={disabled || ekleniyor} onClick={ekle}>
              {ekleniyor ? 'ADDING…' : 'ADD'}
            </button>
          </div>
          {hata && <div style={{ ...S.not, color:C.red }}>{hata}</div>}
          {!dilimSorulmali(cc) && !!cc && (
            <div style={S.not}>Timezone: {tekDilim(cc) || '—'}</div>
          )}
        </div>
      )}
    </div>
  );
}
